/**
 * Returns the browser's IANA timezone (e.g. `America/Los_Angeles`) so signup
 * flows can persist the user's real timezone instead of a server-side default.
 *
 * Returns `undefined` when the environment can't resolve a timezone (older
 * browsers, SSR); callers should treat that as "let the server decide".
 */
export function detectTimezone(): string | undefined {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
}
